export const SBOTD_HEADING = 'Special Buy Of The Day';
export const PRO_HEADING = 'Pro Special Buy Of The Week';
export const DAILY_DEALS_HEADING = 'Daily Deals';
export const INITIAL_NUM_ITEMS_TO_LOAD = 9;
export const MAX_NUM_ITEMS_TO_LOAD = 16;

export const FEATURE_SWITCH_KEYS = {
  isDailyDealsEnabled: 'fs:pricing--isDailyDealsEnabled',
};